export const servers = ['https://fhir-api.zapehr.com'];
